import { Link } from "react-router-dom"

export const Footer = () => {
  return (
    <footer>
      <p>&copy; 2030 <Link to="/">WriteNode</Link>. All Rights Reserved.</p>
    </footer>
  )
}
